import { Component } from "react";

export default class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError)
      return (
        <div className="flex items-center justify-center h-screen text-text_muted text-sm">
          Something went wrong. Please refresh the page.
        </div>
      );
    return this.props.children;
  }
}
